import { render } from "./stage2.vue?vue&type=template&id=64959bb8&scoped=true"
import script from "./stage2.vue?vue&type=script&lang=js"
export * from "./stage2.vue?vue&type=script&lang=js"

import "./stage2.vue?vue&type=style&index=0&id=64959bb8&scoped=true&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/_DKRx8o2/0/web/speechki_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64959bb8"]])

export default __exports__